import React from 'react';
import { Student } from '@/types/models';
import StudentCard from './StudentCard';
import { Card, CardContent } from '@/components/ui/card';

interface StudentsSectionProps {
  students: Student[];
  onAddStudent: () => void;
  onEditStudent?: (student: Student) => void;
  expanded?: boolean;
}

const StudentsSection = ({ 
  students, 
  onAddStudent,
  onEditStudent,
  expanded = false 
}: StudentsSectionProps) => {
  // Direct handler to pass to StudentCard
  const handleStudentEdit = (student: Student) => {
    console.log("StudentsSection DIRECT: Passing edit for student:", student.id);
    if (onEditStudent) {
      onEditStudent(student);
    }
  };

  if (!students || students.length === 0) {
    return (
      <div className="p-2">
        <div className="text-center py-6">
          <p className="text-sm text-muted-foreground mb-4">No students in this family</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {students.map((student) => (
        <Card
          key={student.id}
          className={`relative hover:border-primary/50 transition-colors ${expanded ? 'p-4' : 'p-2'}`}
        >
          <CardContent className="p-0 cursor-pointer" onClick={() => handleStudentEdit(student)}>
            <div className="font-medium">
              {student.first_name} {student.last_name}
            </div>
            {student.date_of_birth && (
              <div className="text-sm text-muted-foreground">
                DOB: {new Date(student.date_of_birth).toLocaleDateString()}
              </div>
            )}
            {expanded && student.gender && (
              <div className="text-sm text-muted-foreground mt-1">
                Gender: {student.gender}
              </div>
            )}
            {expanded && student.notes && (
              <div className="text-sm text-muted-foreground mt-2 italic">
                "{student.notes}"
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default StudentsSection;
//comment